<template>
	<div class="generic-modal">
		<div class="bg-overlay" @click="closeModal" />

		<div 
			class="modal-content"
			:class="{ 'wider': wider }"
			>
			<div class="title-bar">
				<div class="the-title">
					{{ title }}
				</div>
				<div class="close-button" @click="closeModal">
					<i class="fal fa-times" />
				</div>
			</div>

			<div class="modal-body">
				<slot />
			</div>

			<div class="loading-overlay" v-if="loading">
				<Loader3dot />
			</div>
		</div>

	</div>
</template>

<script>

import Loader3dot from "@/Components/Atoms/Loader3dot"

export default {
	components: {
		Loader3dot
	},
	props: {
		title: {
			type: String,
			default: 'Title'
		},
		loading: {
			type: Boolean,
			default: false
		},
		wider: {
			type: Boolean,
			default: false
		}
	},
	data: () => {
		return {
			
		}
	},
	methods: {
		closeModal(){
			if(!this.loading){
				this.$emit('close')
			}
		}
	},
	mounted(){
		
	}
};

</script>

<style lang="sass" scoped>

.generic-modal
	position: fixed
	z-index: 9999
	top: 0
	left: 0
	right: 0
	bottom: 0
	display: flex
	align-items: center
	justify-content: center

	.bg-overlay
		position: fixed
		z-index: 1
		top: 0
		left: 0
		right: 0
		bottom: 0
		background: rgba(0, 0, 0, 0.5)
		backdrop-filter: blur(5px)
		-webkit-backdrop-filter: blur(5px)
		padding: 20px

	.modal-content
		position: relative
		z-index: 2
		background: white
		border-radius: 8px
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1)
		width: 100%
		max-width: 500px
		overflow: hidden

		&.wider
			max-width: 800px

		.title-bar
			display: flex
			align-items: center
			justify-content: space-between
			padding: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.1)

			.the-title
				font-size: 24px
				font-weight: 700
				font-family: 'Roboto Condensed', sans-serif
				color: #252525
				line-height: 1.1

			.close-button
				cursor: pointer
				i
					font-size: 24px
					color: #252525
					transition: all 0.3s ease


		.modal-body
			padding: 20px
			font-size: 18px
			font-weight: 400
			font-family: 'Roboto Condensed', sans-serif
			color: #252525
			line-height: 1.1
			overflow: auto
			max-height: 70vh
			display: flex
			flex-direction: column
			gap: 5px

		.loading-overlay
			position: absolute
			z-index: 3
			top: 0
			left: 0
			right: 0
			bottom: 0
			display: flex
			align-items: center
			justify-content: center
			background: rgba(255, 255, 255, 0.8)
			backdrop-filter: blur(5px)
			-webkit-backdrop-filter: blur(5px)

			// .loading
			// 	width: 100px
			// 	height: 100px
			// 	border-radius: 50%
			// 	border: 5px solid #252525
			// 	border-top: 5px solid #f00
			// 	animation: spin 2s linear infinite


</style>